'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommonMessageFormat = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../constants/messageTypes');

var _messageTypes2 = require('../../pubnub-message/constants/messageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isCommonMessageFormat = exports.isCommonMessageFormat = function isCommonMessageFormat(message) {
  return (0, _get2.default)(_messageTypes2.MESSAGE_TYPE_ID, message) === _messageTypes.COMMON_MESSAGE;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/operators/isCommonMessageFormat.js
// module id = 133
// module chunks = 2 3